const chatMicrophone = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M9.136 10.203a3.083 3.083 0 0 1-4.264-2.85v-4.27a3.084 3.084 0 0 1 6.168 0v4.27a3.085 3.085 0 0 1-1.904 2.85M6.782 1.91a1.66 1.66 0 0 0-.487 1.174v4.27a1.66 1.66 0 1 0 3.321 0v-4.27A1.66 1.66 0 0 0 6.782 1.91m5.207 4.95h1.423v.482a5.456 5.456 0 0 1-4.744 5.408v1.827h1.66V16H5.584v-1.423h1.66V12.75A5.456 5.456 0 0 1 2.5 7.354V6.86h1.423v.494a4.033 4.033 0 0 0 8.066 0z" clip-rule="evenodd"/></svg>',
};

export { chatMicrophone as default };
